(function () {
    'use strict';
    angular.module('app.common')
        .directive('agentCard', ['$timeout', function ($timeout) {
            var directive = {
                templateUrl: '/app/common/agent-card.html',
                scope: {
                    agent: '<'
                },
                restrict: 'EA',
                // bindToController: false,
                replace: false, 
                // priority: 1000, //this setting is important, see explanation below
                link: function(scope, element, attrs) {
                    scope.star = function (id, value) {
                        $timeout(function () {
                            var name = "#starRating" + id;
                            $(name).barrating({
                                theme: "fontawesome-stars",
                                readonly: true,
                                initialRating: value,
                                allowEmpty: true,
                                emptyValue: 0
                            });
                            $("a[data-rating-value='? undefined:undefined ?']").hide();
                        }, 0);
                    };

                    scope.region = scope.agent.Regions.length > 1 ? 
                        scope.agent.Regions.find((f) => f.isManuelRegion === false) :
                        scope.agent.Regions[0]
                }
            };
            return directive;
        }]);
})();